export const classes = {
  storefront:
    'grid grid-cols-[1fr_400px] gap-[30px] px-[26px] pt-[14px] max-lg:grid-cols-1 max-lg:pb-5 max-sm:px-4',
  leftColumn: 'flex min-w-0 flex-col gap-[22px]',
  rightColumn: 'flex flex-col gap-[14px] max-lg:order-first',
  page: 'mx-auto flex min-h-dvh w-full max-w-[1440px] flex-col pb-10 max-lg:pb-0',
  header: 'mb-1.5 mt-4 px-[22px] max-sm:px-3',
  content: 'flex-1',
};
